"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
/**
 * OMReference stores a strongly types pointer (uuid) to an object that exists
 * either on device cache, or remotely on the server
 */
class OMReference {
    constructor(referencedClazz, value) {
        this.referencedClazz = referencedClazz;
        if (typeof value === "string") {
            this.id = value;
            return;
        }
        if (value.id) {
            this.id = value.id;
        }
        else {
            this.id = value.id;
        }
    }
    get objectType() {
        return this.referencedClazz.Type;
    }
    /**
     * actualObject is used to retrieve object refered do by this reference.
     *
     * @returns {OMObjectType|undefined} Either the actual object referenced,
     *  or undefined if object does not exist in current device cache
     */
    get actualObject() {
        return __1.OMUniverse.shared.find(this.referencedClazz, this.id);
    }
    /**
     * Asynchronously loads and returns the actualObject from server
     */
    load(query = this.referencedClazz.query()) {
        return __awaiter(this, void 0, void 0, function* () {
            return query
                .clone()
                .filter("id", "equals", this.id)
                .execute()
                .then((refs) => refs[0].actualObject);
        });
    }
    toJSON() {
        return {
            id: this.id,
            type: this.objectType,
        };
    }
}
OMReference.Path = "";
exports.default = OMReference;
//# sourceMappingURL=OMReference.js.map